import { render, staticRenderFns } from "./SupplierInfo.vue?vue&type=template&id=365541fe&scoped=true"
import script from "./SupplierInfo.vue?vue&type=script&lang=js"
export * from "./SupplierInfo.vue?vue&type=script&lang=js"
import style0 from "./SupplierInfo.vue?vue&type=style&index=0&id=365541fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365541fe",
  null
  
)

/* custom blocks */
import block0 from "@/locales2/share/ratingValue.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusr%2Fsrc%2Fapp%2Fsrc%2Fcomponents%2Frecord_detail_v2%2Forder_status%2FSupplierInfo.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports